import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {DWPValidatorsService} from '../../dwpvalidators.service';
import {PreviousAgContract} from './previous-ag-contract.model';

@Component({
  selector: 'app-previous-ag-contract',
  templateUrl: './previous-ag-contract.component.html',
  styleUrls: ['./previous-ag-contract.component.css']
})
export class PreviousAgContractComponent implements OnInit {

  form: UntypedFormGroup;
  @Output()
  previousAgContract: EventEmitter<PreviousAgContract> = new EventEmitter<PreviousAgContract>();

  constructor(private formBuilder: UntypedFormBuilder, private validators: DWPValidatorsService) {

    this.form = formBuilder.group({
      contractType: new UntypedFormControl('', [validators.notBlank]),
      endDate: new UntypedFormControl('', [validators.date])
    });
  }

  ngOnInit(): void {
  }

  disable() {
    return false;
  }

  emit(): void {
    if (this.form.valid) {
      const agContract: PreviousAgContract = {
        contractType: this.form.get('contractType').value,
        endDate: this.form.get('endDate').value
      };
      this.previousAgContract.emit(agContract);
    } else {
      this.previousAgContract.emit(null);
    }

  }

}
